import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Camera, Heart, Loader2 } from 'lucide-react';
import axios from 'axios';
import GalleryDonateTab from '../components/GalleryDonateTab';
import FloatingDonateTab from '../components/FloatingDonateTab';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function GalleryLivePage() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const resolve = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/public/galleries/live/redirect`);
        if (res.data.active && res.data.gallery_id) {
          navigate(`/gallery/${res.data.gallery_id}/upload`, { replace: true });
          return;
        }
      } catch {}
      setChecking(false);
    };
    resolve();
  }, [navigate]);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
        <GalleryDonateTab />
        <FloatingDonateTab />
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-[#BA1826] mx-auto mb-3" />
          <p className="text-sm text-[#4B5563]">Finding your event gallery...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6" data-testid="gallery-live-inactive">
      <GalleryDonateTab />
      <FloatingDonateTab />
      <div className="text-center max-w-sm">
        <div className="w-20 h-20 bg-[#FEE2E2] rounded-full flex items-center justify-center mx-auto mb-5">
          <Camera className="w-8 h-8 text-[#BA1826]" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-[#0A0A0A] mb-3">No Active Gallery</h1>
        <p className="text-sm text-[#4B5563] leading-relaxed mb-6">
          There's no active event gallery right now. Follow us or check back at our next event to share your photos!
        </p>
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[#BA1826] hover:underline">
          <Heart className="w-4 h-4" fill="#BA1826" />
          Visit Novena Humanitarian Foundation
        </Link>
      </div>
    </div>
  );
}
